import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Prompt } from 'react-router-dom';
import Text, { TEXT } from '~/view/components/Text/Text';
import ConsumerChannelsConfigHeaderLinks from '~/view/screens/SettingsScreen/screens/OrderingChannel/containers/ConsumerChannelsConfigHeaderLinks/ConsumerChannelsConfigHeaderLinks';
import ImageBlock from '~/view/screens/SettingsScreen/screens/OrderingChannel/containers/ImageBlock/ImageBlock';
import Button from '~/view/components/Controls/ButtonComponent/Button';
import { allowedImageTypes } from '~/view/components/Controls/Upload/constants';
import { getPromptProps } from '~/view/components/CustomPrompt/helper';
import { localeStore } from '~/mobx/localesStore';
import { BUTTON_TITLE } from '~/constants/main';
import { scrollToErrorElement } from '~/utils/helpers';
import dookConfigStore from '~/view/screens/SettingsScreen/screens/OrderingChannel/screens/DookConfigScreen/store';
import './style.scss';

const DookConfigScreen = observer(() => {
  useEffect(() => {
    return () => dookConfigStore.clear();
  }, []);

  const handleImageUpload = ({ full, md }: { full: string; md: string }) => {
    dookConfigStore.changeImage({ bannerImage: full, bannerImageMd: md });
  };

  const handleSubmit = () => {
    dookConfigStore.setValidation();

    if (dookConfigStore.isValid) {
      dookConfigStore.updateConfig();
    } else {
      scrollToErrorElement();
    }
  };

  return (
    <div className="d-flex flex-column flex-1 mt-6">
      <ConsumerChannelsConfigHeaderLinks />
      <div className="mt-6">
        <Text type={TEXT.SECTION_HEADER} text="images_tab" />
        <ImageBlock
          type="dook_banner"
          title="restaurant_card"
          image={dookConfigStore.config.bannerImage}
          uploadImage={handleImageUpload}
          validation={{ isValid: dookConfigStore.validation.isValidBannerImage }}
          hints={['dook_image_guideline_1', 'dook_image_guideline_2', 'dook_image_guideline_3']}
          required
          maxSize={256000} // 250 KB
          reqResolution="1020x480 px"
          allowedTypes={allowedImageTypes}
          className="dook-image mt-4"
          small
          uploadWrapperClassName="dook-image__uploader"
        />
      </div>
      <Button title={localeStore.t(BUTTON_TITLE.SAVE)} onClick={handleSubmit} className="mt-8" />

      <Prompt when={dookConfigStore.isEdited} message={getPromptProps()} />
    </div>
  );
});

export default DookConfigScreen;
